import React from 'react';
import { ConnectOptions } from 'twilio-video';
import { useAppState } from '../../../state';
import ErrorDialog from '../../../components/ErrorDialog/ErrorDialog';
import { VideoProvider } from '../../../components/VideoProvider';
import App from './App';

const connectionOptions: ConnectOptions  = {
	bandwidthProfile: {
	  video: {
		mode: 'collaboration',
		renderDimensions: {
		  high: { height: 1080, width: 1920 },
		  standard: { height: 90, width: 160 },
		  low: { height: 90, width: 160 },
		},
	  },
	},
	dominantSpeaker: true,
	maxAudioBitrate: 12000,
	networkQuality: { local: 1, remote: 1 },
	preferredVideoCodecs: [{ codec: 'VP8', simulcast: true }],
  };

export default function VideoApp(props: any) {
    const { error, setError } = useAppState();
	return (
	  <VideoProvider options={connectionOptions} onError={setError}>
		<ErrorDialog dismissError={() => {
		//   window.location.replace('/thank-you');
			if(error && (error.code === 53403 || error.code === 53205 )){
				window.location.reload();
			}
		
			window.localStorage.removeItem("therapistCallId");
			window.sessionStorage.removeItem("twilioTherapistToken");
            window.sessionStorage.setItem('therapistConnecting', "no");
		  	return setError(null)
		  }} error={error} />
		<App {...props}/>
	  </VideoProvider>
	);
}
